import { render, staticRenderFns } from "./NewServicesExternal.vue?vue&type=template&id=9875cf0e&scoped=true&"
import script from "./NewServicesExternal.vue?vue&type=script&lang=js&"
export * from "./NewServicesExternal.vue?vue&type=script&lang=js&"
import style0 from "./NewServicesExternal.vue?vue&type=style&index=0&id=9875cf0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9875cf0e",
  null
  
)

export default component.exports